// @react/hooks/useAffiliateReferralLink.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateReferralLinkStore } from '@core/stores';

/**
 * React hook for ReferralLink operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliateReferralLink } from '@react/hooks';
 *
 * const ReferralLinkList = observer(() => {
 *   const store = useAffiliateReferralLink();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliateReferralLink() {
  return affiliateReferralLinkStore;
}
